import React from 'react';
import { withLocalize, Translate } from 'react-localize-redux';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import FilterListIcon from '@material-ui/icons/FilterList';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import IconButton from '@material-ui/core/IconButton';
import MenuItem from '@material-ui/core/MenuItem';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Select from '@material-ui/core/Select';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import FormLabel from '@material-ui/core/FormLabel';
import Popover from '@material-ui/core/Popover';
import TextField from '@material-ui/core/TextField';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import DynamoDBChargeboxes from '../../../aws/dynamodb/chargeboxes';
import chargeboxes from '../../../aws/dynamodb/chargeboxes';

const styles = {
  buttonsContainer: {
    marginBottom: '1rem',
  },
  email: {
    flex: 1,
    marginRight: '1rem',
  },
  filtersContainer: {
    padding: '1rem',
  },
  listItemIcon: {
    minWidth: '2rem',
  },
};
const MinValues = { eur: 0.5, usd: 0.5, gbp: 0.3, chf: 0.5 };

const Days = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];

const Hours = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24];

const FiltersMenu = (props) => {
  let [alias, setAlias] = React.useState('');
  let [vehicle, setVehicle] = React.useState('');

  React.useEffect(() => {
    if (props.anchorEl === null) {
      setAlias(props.filters.alias);
      setVehicle(props.filters.vehicle);
    }
  }, [props.anchorEl, props.filters.alias, props.filters.vehicle]);
  return (
    <Popover
      anchorEl={props.anchorEl}
      open={props.anchorEl !== null}
      onClose={props.onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      PaperProps={{ className: props.classes.filtersContainer }}
    >
      <Grid container spacing={3} direction='column'>
        <Grid item>
          <Typography color='textSecondary'>
            <Translate id='filter' />
          </Typography>
        </Grid>
        <Grid item>
          <TextField label={<Translate id='chargeboxes.alias' />} value={alias} onChange={(e) => setAlias(e.target.value)} fullWidth />
        </Grid>
        <Grid item>
          <FormControl component='fieldset'>
            <FormLabel component='legend'>
              <Translate id='chargeboxes.vehicle' />
            </FormLabel>
            <RadioGroup aria-label='vehicle' value={vehicle} onChange={(e) => setVehicle(e.target.value)}>
              <FormControlLabel value='car' control={<Radio color='primary' />} label={<Translate id='vehicles.car' />} />
              <FormControlLabel value='bicycle' control={<Radio color='primary' />} label={<Translate id='vehicles.bicycle' />} />
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid item container direction='row' alignItems='center' justifyContent='center'>
          <Button
            onClick={() => {
              setAlias('');
              setVehicle('');
            }}
          >
            <Translate id='chargeboxes.filters.clear' />
          </Button>
          <Button color='primary' onClick={() => props.submit(alias, vehicle)}>
            <Translate id='chargeboxes.filters.submit' />
          </Button>
        </Grid>
      </Grid>
    </Popover>
  );
};

class RfidsDialogCustomPayment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      type: '',
      unit: '',
      currency: 'eur',
      amount: '',
      minimumThreshold: null,
      showRemove: false,
      theshold_hour: '',
      start_charge: '',
      timeslotEnabled: false,
      amountInc: '',
      thresholdInc: '',
      days: [
        { start: '', end: '' },
        { start: '', end: '' },
        { start: '', end: '' },
        { start: '', end: '' },
        { start: '', end: '' },
        { start: '', end: '' },
        { start: '', end: '' },
      ],
      chargeboxes: null,
      chargeboxMode: '',
      activeStep: 0,
      email: '',
      filtersMenuAnchorEl: null,
      ClientChargeboxes: [],
      filters: {
        alias: '',
        vehicle: '',
      },
      processing: false,
    };

    this.onChange = this.onChange.bind(this);
    this.cancel = this.cancel.bind(this);
    this.canSubmit = this.canSubmit.bind(this);
    this.removeCustomPayment = this.removeCustomPayment.bind(this);
    this.submit = this.submit.bind(this);
    this.openCloseFilters = this.openCloseFilters.bind(this);
    this.getFilteredChargeboxes = this.getFilteredChargeboxes.bind(this);
    this.secureSetState = this.secureSetState.bind(this);
    this._isMounted = false;
  }

  get isMounted() {
    return this._isMounted;
  }

  set isMounted(val) {
    this._isMounted = val;
  }

  handleNext = () => {
    this.setState({ activeStep: this.state.activeStep + 1 });
  };

  handleBack = () => {
    this.setState({ activeStep: this.state.activeStep - 1 });
  };

  secureSetState(state, callback) {
    if (!this.isMounted) {
      return;
    }
    this.setState(state, callback);
  }

  onChange(e) {
    let { name, value } = e.target;
    switch (name) {
      case 'type':
        this.secureSetState({
          type: value,
          unit: '',
          currency: 'eur',
          amount: '',
          minimumThreshold: null,
          theshold_hour: '',
          start_charge: '',
          timeslotEnabled: false,
          amountInc: '',
          thresholdInc: '',
          days: [
            { start: '', end: '' },
            { start: '', end: '' },
            { start: '', end: '' },
            { start: '', end: '' },
            { start: '', end: '' },
            { start: '', end: '' },
            { start: '', end: '' },
          ],
          activeStep: 0,
        });
        break;
      case 'amount':
        if (value.length === 0) {
          this.secureSetState({ [name]: '' });
        } else if (/^\d+(\.(\d+)?)?$/gim.test(value)) {
          this.secureSetState({ [name]: value });
        }
        break;
      case 'theshold_hour':
        if (value.length === 0) {
          this.secureSetState({ [name]: '' });
        } else if (/^\d+(\.(\d+)?)?$/gim.test(value)) {
          this.secureSetState({ [name]: value });
        }
        break;
      case 'start_charge':
        if (value.length === 0) {
          this.secureSetState({ [name]: '' });
        } else if (/^\d+(\.(\d+)?)?$/gim.test(value)) {
          this.secureSetState({ [name]: value });
        }
        break;
      case 'minimumThreshold':
        if (value.length === 0) {
          this.secureSetState({ [name]: null });
        } else if (/^\d+$/gim.test(value)) {
          this.secureSetState({ [name]: parseInt(value, 10) });
        }
        break;
      case 'timeslotEnabled':
        this.secureSetState({ [name]: !this.state[name] });
        break;
      case 'amountInc':
        if (value.length === 0) {
          this.secureSetState({ [name]: '' });
        } else if (/^\d+(\.(\d+)?)?$/gim.test(value)) {
          this.secureSetState({ [name]: value });
        }
        break;
      case 'thresholdInc':
        if (value.length === 0) {
          this.secureSetState({ [name]: '' });
        } else if (/^\d+(\.(\d+)?)?$/gim.test(value)) {
          this.secureSetState({ [name]: value });
        }
        break;
      case '0.start':
      case '1.start':
      case '2.start':
      case '3.start':
      case '4.start':
      case '5.start':
      case '6.start':
      case '0.end':
      case '1.end':
      case '2.end':
      case '3.end':
      case '4.end':
      case '5.end':
      case '6.end':
        let names = name.split('.');
        let days = [...this.state.days];
        days[parseInt(names[0])][names[1]] = value;

        if (names[1] === 'end') {
          if (value < days[parseInt(names[0])].start) {
            break;
          }
        }
        this.secureSetState({ days: days });
        break;
      case 'chargeboxMode':
        if (value === 'all') {
          this.secureSetState({
            chargeboxMode: 'all',
            chargeboxes: null,
          });
        }

        if (value === 'list') {
          if (!Array.isArray(this.state.chargeboxes)) {
            this.secureSetState({
              chargeboxMode: 'list',
              chargeboxes: [],
            });
          } else {
            this.secureSetState({
              chargeboxMode: 'list',
            });
          }
          /*this.secureSetState((prev) => {
            let newValue = prev.chargeboxes;

            if (!Array.isArray(newValue)) {
              newValue = [];
            }

            return {
              chargeboxMode: 'list',
              chargeboxes: newValue,
            };
          });*/
        }
        break;
      case 'chargebox':
        if (this.state.chargeboxMode === 'list') {
          let { chargeboxes } = this.state;
          let newChargeboxes;

          if (chargeboxes.includes(value)) {
            newChargeboxes = chargeboxes.filter((cb) => cb !== value);
          } else {
            newChargeboxes = [...chargeboxes, value];
          }

          this.secureSetState({
            chargeboxes: newChargeboxes,
          });
        }
        break;
      default:
        this.secureSetState({ [name]: value });
        break;
    }
  }

  cancel() {
    this.props.handleClose(false, null);
    this.secureSetState({
      type: '',
      unit: '',
      currency: 'eur',
      amount: '',
      minimumThreshold: null,
      theshold_hour: '',
      start_charge: '',
      amountInc: '',
      thresholdInc: '',
      days: [
        { start: '', end: '' },
        { start: '', end: '' },
        { start: '', end: '' },
        { start: '', end: '' },
        { start: '', end: '' },
        { start: '', end: '' },
        { start: '', end: '' },
      ],
      chargeboxes: null,
      chargeboxMode: '',
      activeStep: 0,
    });
  }

  canSubmit() {
    switch (this.state.type) {
      case 'free':
        return true;

      case 'time-based':
        return (
          this.state.unit.length > 0 &&
          //this.state.currency.length > 0 &&
          /^\d+(\.\d+)?$/gim.test(this.state.amount)
        );
      case 'consume-based':
        if (this.state.timeslotEnabled === true) {
          if (
            /^\d+(\.\d+)?$/gim.test(this.state.amountInc) &&
            /^\d+(\.\d+)?$/gim.test(this.state.thresholdInc) &&
            this.state.days[0].start <= this.state.days[0].end &&
            this.state.days[0].start !== '' &&
            this.state.days[0].end !== '' &&
            this.state.days[1].start <= this.state.days[1].end &&
            this.state.days[1].start !== '' &&
            this.state.days[1].end !== '' &&
            this.state.days[2].start <= this.state.days[2].end &&
            this.state.days[2].start !== '' &&
            this.state.days[2].end !== '' &&
            this.state.days[3].start <= this.state.days[3].end &&
            this.state.days[3].start !== '' &&
            this.state.days[3].end !== '' &&
            this.state.days[4].start <= this.state.days[4].end &&
            this.state.days[4].start !== '' &&
            this.state.days[4].end !== '' &&
            this.state.days[5].start <= this.state.days[5].end &&
            this.state.days[5].start !== '' &&
            this.state.days[5].end !== '' &&
            this.state.days[6].start <= this.state.days[6].end &&
            this.state.days[6].start !== '' &&
            this.state.days[6].end !== ''
          ) {
            return (
              this.state.unit.length > 0 &&
              //this.state.currency.length > 0 &&
              /^\d+(\.\d+)?$/gim.test(this.state.amount) &&
              /^\d+(\.\d+)?$/gim.test(this.state.theshold_hour) &&
              /^\d+(\.\d+)?$/gim.test(this.state.start_charge)
            );
          } else {
            return false;
          }
        } else {
          return (
            this.state.unit.length > 0 &&
            //this.state.currency.length > 0 &&
            /^\d+(\.\d+)?$/gim.test(this.state.amount) &&
            /^\d+(\.\d+)?$/gim.test(this.state.theshold_hour) &&
            /^\d+(\.\d+)?$/gim.test(this.state.start_charge)
          );
        }

      case 'flat':
        return (
          this.state.currency.length > 0 &&
          /^\d+(\.\d+)?$/gim.test(this.state.amount) &&
          MinValues[this.state.currency] <= parseFloat(this.state.amount) &&
          this.state.minimumThreshold !== null
        );
      case 'api':
        return true;

      default:
        return false;
    }
  }

  removeCustomPayment() {
    this.props.handleClose(true, null);
    this.secureSetState({
      type: '',
      unit: '',
      currency: 'eur',
      amount: '',
      minimumThreshold: null,
      timeslotEnabled: false,
      amountInc: '',
      days: [
        { start: '', end: '' },
        { start: '', end: '' },
        { start: '', end: '' },
        { start: '', end: '' },
        { start: '', end: '' },
        { start: '', end: '' },
        { start: '', end: '' },
      ],
      chargeboxes: null,
      chargeboxMode: '',
      activeStep: 0,
    });
  }

  submit() {
    let options = {};
    switch (this.state.type) {
      case 'time-based':
        options = {
          amount: parseFloat(this.state.amount),
          unit: this.state.unit,
          start_charge: parseFloat(this.state.start_charge),
        };
        break;
      case 'consume-based':
        options = {
          unit: this.state.unit,
          currency: this.state.currency,
          amount: parseFloat(this.state.amount),
          theshold_hour: parseFloat(this.state.theshold_hour),
          start_charge: parseFloat(this.state.start_charge),
          timeslotEnabled: this.state.timeslotEnabled,
        };

        if (this.state.timeslotEnabled) {
          options.amountInc = parseFloat(this.state.amountInc);
          options.thresholdInc = parseFloat(this.state.thresholdInc);
          options.days = this.state.days;
        }
        break;
      case 'api':
        options = {};
        break;
      case 'flat':
        options = {
          minimum_threshold: this.state.minimumThreshold,
          currency: this.state.currency,
          amount: parseFloat(this.state.amount),
        };
        break;

      default:
        break;
    }
    if (this.state.chargeboxMode === 'list') {
      this.props.handleClose(true, { type: this.state.type, options, chargeboxes: this.state.chargeboxes });
    } else {
      this.props.handleClose(true, { type: this.state.type, options });
    }
    this.secureSetState({ activeStep: 0 });
  }

  componentDidMount() {
    this.isMounted = true;
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.open && this.props.open) {
      this.secureSetState({ processing: true }, async () => {
        if (this.props.chargebox.hasOwnProperty('custom_payment') && this.props.chargebox.custom_payment !== null) {
          let type = this.props.chargebox.custom_payment.type;
          let unit = this.props.chargebox.custom_payment.options.unit || '';
          let currency = this.props.currencies[this.props.chargebox.client] || 'eur';
          let amount = this.props.chargebox.custom_payment.options.hasOwnProperty('amount')
            ? this.props.chargebox.custom_payment.options.amount.toString()
            : '';
          let theshold_hour = this.props.chargebox.custom_payment.options.hasOwnProperty('theshold_hour')
            ? this.props.chargebox.custom_payment.options.theshold_hour.toString()
            : '';
          let start_charge = this.props.chargebox.custom_payment.options.hasOwnProperty('start_charge')
            ? this.props.chargebox.custom_payment.options.start_charge.toString()
            : '';
          let minimumThreshold = this.props.chargebox.custom_payment.options.minimum_threshold || null;
          let timeslotEnabled = this.props.chargebox.custom_payment.options.timeslotEnabled;
          let amountInc = this.props.chargebox.custom_payment.options.hasOwnProperty('amountInc')
            ? this.props.chargebox.custom_payment.options.amountInc.toString()
            : '';
          let thresholdInc = this.props.chargebox.custom_payment.options.hasOwnProperty('thresholdInc')
            ? this.props.chargebox.custom_payment.options.thresholdInc.toString()
            : '';
          let days = this.props.chargebox.custom_payment.options.hasOwnProperty('days')
            ? this.props.chargebox.custom_payment.options.days
            : [
                { start: '', end: '' },
                { start: '', end: '' },
                { start: '', end: '' },
                { start: '', end: '' },
                { start: '', end: '' },
                { start: '', end: '' },
                { start: '', end: '' },
              ];

          let chargeboxes = this.props.chargebox.custom_payment.hasOwnProperty('chargeboxes') ? this.props.chargebox.custom_payment.chargeboxes : null;

          let chargeboxMode = this.props.chargebox.custom_payment.chargeboxes ? 'list' : 'all';

          let data = await DynamoDBChargeboxes.getAll({ type: 'client', client: this.props.chargebox.client });

          let ClientChargeboxes = [];
          for (let item in data.Items) {
            let chargebox = {
              id: data.Items[item].id,
              alias: data.Items[item].alias,
              vehicle: data.Items[item].type.vehicle,
            };
            ClientChargeboxes.push(chargebox);
          }

          this.secureSetState({
            type,
            unit,
            currency,
            amount,
            minimumThreshold,
            showRemove: true,
            theshold_hour,
            start_charge,
            timeslotEnabled,
            amountInc,
            thresholdInc,
            days,
            chargeboxes,
            ClientChargeboxes,
            chargeboxMode,
            processing: false,
          });
        } else {
          this.secureSetState({
            type: '',
            unit: '',
            currency: 'eur',
            amount: '',
            minimumThreshold: null,
            showRemove: false,
            theshold_hour: '',
            start_charge: '',
            timeslotEnabled: false,
            amountInc: '',
            thresholdInc: '',
            days: [
              { start: '', end: '' },
              { start: '', end: '' },
              { start: '', end: '' },
              { start: '', end: '' },
              { start: '', end: '' },
              { start: '', end: '' },
              { start: '', end: '' },
            ],
            chargeboxes: null,
            processing: false,
          });
        }
      });
    }
  }

  componentWillUnmount() {
    this.isMounted = false;
  }

  openCloseFilters(event) {
    if (this.state.filtersMenuAnchorEl === null) {
      this.secureSetState({ filtersMenuAnchorEl: event.currentTarget });
    } else {
      this.secureSetState({ filtersMenuAnchorEl: null });
    }
  }

  getFilteredChargeboxes(alias, vehicle) {
    if (this.state.processing) {
      return;
    }
    this.secureSetState({ processing: true }, async () => {
      try {
        let filters = {};
        if (alias.length > 0) {
          filters.alias = alias;
        }
        if (this.props.chargebox.client.length > 0) {
          filters.client = this.props.chargebox.client;
        }
        if (vehicle.length > 0) {
          filters.type = { vehicle: vehicle };
        }
        let records = await DynamoDBChargeboxes.getAll(
          {
            type: this.context.type,
            client: this.context.client,
          },
          null,
          filters,
        );

        let ClientChargeboxes = [];
        for (let item in records.Items) {
          let chargebox = {
            id: records.Items[item].id,
            alias: records.Items[item].alias,
            vehicle: records.Items[item].type.vehicle,
          };
          ClientChargeboxes.push(chargebox);
        }
        this.secureSetState({ ClientChargeboxes: ClientChargeboxes, filters: { vehicle, alias }, processing: false, filtersMenuAnchorEl: null });
      } catch (err) {
        console.log(err);
        this.secureSetState({ ClientChargeboxes: [], processing: false });
      }
    });
  }

  render() {
    let rfidDescription = null;
    if (this.props.chargebox.user === null) {
      rfidDescription = (
        <React.Fragment>
          <Typography component='p' variant='body2'>
            {this.props.chargebox.id}
          </Typography>
          <Typography component='p' variant='body2'>
            {this.props.chargebox.alias}
          </Typography>
        </React.Fragment>
      );
    } else if (this.props.users.hasOwnProperty(this.props.chargebox.user)) {
      rfidDescription = (
        <React.Fragment>
          <Typography component='p' variant='body2'>
            {this.props.chargebox.id}
          </Typography>
          <Typography component='p' variant='body2'>
            {this.props.users[this.props.chargebox.user].name || this.props.users[this.props.chargebox.user].company_name}
          </Typography>
          <Typography component='p' variant='caption'>
            {this.props.users[this.props.chargebox.user].email}
          </Typography>
        </React.Fragment>
      );
    }

    let fields = null;
    let currency = '€';
    if (this.props.chargebox && this.props.chargebox.client) {
      switch (this.props.currencies[this.props.chargebox.client]) {
        case 'chf':
          currency = 'chf';
          break;
        case 'eur':
        default:
          currency = '€';
          break;
      }
    }
    switch (this.state.type) {
      case 'time-based':
        fields = (
          <Grid container direction='column' alignItems='stretch' justifyContent='flex-start'>
            <FormControl>
              <InputLabel id='chargebox-custom-payment-time-unit'>
                <Translate id='paymentTypes.timeUnit' />
              </InputLabel>
              <Select labelId='chargebox-custom-payment-time-unit' name='unit' value={this.state.unit} onChange={this.onChange}>
                <MenuItem value='min'>
                  <Translate id='paymentTypes.minute' />
                </MenuItem>
                <MenuItem value='hour'>
                  <Translate id='paymentTypes.hour' />
                </MenuItem>
              </Select>
            </FormControl>
            <Grid container direction='row' spacing={2}>
              <Grid item xs={12}>
                <TextField
                  label={this.props.translate('paymentTypes.amount')}
                  value={this.state.amount}
                  name='amount'
                  onChange={this.onChange}
                  fullWidth
                  InputProps={{
                    startAdornment: <InputAdornment position='start'>{currency}</InputAdornment>,
                  }}
                />
              </Grid>
            </Grid>
            <Grid container direction='row' spacing={2}>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <InputLabel id='payment-type-start_charge'>
                    <Translate id='paymentTypes.start_charge' />
                  </InputLabel>
                  <Input
                    label={this.props.translate('paymentTypes.start_charge')}
                    value={this.state.start_charge}
                    name='start_charge'
                    onChange={this.onChange}
                    fullWidth
                    startAdornment={<InputAdornment position='start'>{currency}</InputAdornment>}
                  />
                </FormControl>
                <Typography variant='caption'>
                  <Translate id='paymentTypes.start_charge1' />
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        );
        break;
      case 'consume-based':
        fields = (
          <Grid container direction='column' alignItems='stretch' justifyContent='flex-start'>
            <FormControl>
              <InputLabel id='chargebox-custom-payment-consume-unit'>
                <Translate id='paymentTypes.consumeUnit' />
              </InputLabel>
              <Select labelId='chargebox-custom-payment-consume-unit' name='unit' value={this.state.unit} onChange={this.onChange}>
                <MenuItem value='wh'>
                  <Translate id='paymentTypes.wh' />
                </MenuItem>
                <MenuItem value='kwh'>
                  <Translate id='paymentTypes.kwh' />
                </MenuItem>
              </Select>
            </FormControl>
            <Grid container direction='row' spacing={2}>
              <Grid item xs={12}>
                <TextField
                  label={this.props.translate('paymentTypes.amount')}
                  value={this.state.amount}
                  name='amount'
                  onChange={this.onChange}
                  fullWidth
                  InputProps={{
                    startAdornment: <InputAdornment position='start'>{currency}</InputAdornment>,
                  }}
                />
              </Grid>
            </Grid>
            <Grid container direction='row' spacing={2}>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <InputLabel id='payment-type-theshold_hour'>
                    <Translate id='paymentTypes.theshold_hour' />
                  </InputLabel>
                  <Input
                    label={this.props.translate('paymentTypes.theshold_hour')}
                    value={this.state.theshold_hour}
                    name='theshold_hour'
                    onChange={this.onChange}
                    fullWidth
                    startAdornment={<InputAdornment position='start'>{currency}</InputAdornment>}
                  />
                </FormControl>
                <Typography variant='caption'>
                  <Translate id='paymentTypes.theshold_hour1' />
                </Typography>
              </Grid>
            </Grid>
            <Grid container direction='row' spacing={2}>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <InputLabel id='payment-type-start_charge'>
                    <Translate id='paymentTypes.start_charge' />
                  </InputLabel>
                  <Input
                    label={this.props.translate('paymentTypes.start_charge')}
                    value={this.state.start_charge}
                    name='start_charge'
                    onChange={this.onChange}
                    fullWidth
                    startAdornment={<InputAdornment position='start'>{currency}</InputAdornment>}
                  />
                </FormControl>
                <Typography variant='caption'>
                  <Translate id='paymentTypes.start_charge1' />
                </Typography>
              </Grid>
            </Grid>
            <FormControlLabel
              value='end'
              control={<Checkbox checked={this.state.timeslotEnabled} name='timeslotEnabled' onClick={this.onChange} color='primary' />}
              label={this.props.translate('chargeboxes.timeslot')}
              labelPlacement='end'
            />
            {this.state.timeslotEnabled && (
              <>
                <Grid container direction='row' spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      label={this.props.translate('chargeboxes.timeslotamount')}
                      value={this.state.amountInc}
                      name='amountInc'
                      onChange={this.onChange}
                      fullWidth
                      InputProps={{
                        startAdornment: <InputAdornment position='start'>{currency}</InputAdornment>,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl fullWidth>
                      <InputLabel id='payment-type-theshold_hour_inc'>
                        <Translate id='paymentTypes.theshold_hour_inc' />
                      </InputLabel>
                      <Input
                        label={this.props.translate('paymentTypes.theshold_hour_inc')}
                        value={this.state.thresholdInc}
                        name='thresholdInc'
                        onChange={this.onChange}
                        fullWidth
                        startAdornment={<InputAdornment position='start'>{currency}</InputAdornment>}
                      />
                    </FormControl>
                    <Typography variant='caption'>
                      <Translate id='paymentTypes.theshold_hour_inc1' />
                    </Typography>
                  </Grid>
                </Grid>
                <br></br>
                <Table aria-label='table' size='small' fullWidth item>
                  <TableHead>
                    <TableCell></TableCell>
                    {Days.map((e) => (
                      <TableCell
                        align='center'
                        sx={{
                          margin: 'auto',
                        }}
                      >
                        <Translate id={`chargeboxes.days.${e}`} />
                      </TableCell>
                    ))}
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell
                        align='center'
                        sx={{
                          margin: 'auto',
                        }}
                      >
                        <Translate id={'chargeboxes.days.startHour'} />
                      </TableCell>
                      {Days.map((e) => (
                        <TableCell
                          align='center'
                          sx={{
                            margin: 'auto',
                          }}
                        >
                          <Select
                            labelId='chargebox-custom-payment-consume-unit'
                            name={`${Days.indexOf(e)}.start`}
                            value={this.state.days[Days.indexOf(e)].start}
                            onChange={this.onChange}
                          >
                            {Hours.map((h) => (
                              <MenuItem value={h}>{h}</MenuItem>
                            ))}
                          </Select>
                        </TableCell>
                      ))}
                    </TableRow>
                    <TableRow>
                      <TableCell
                        align='center'
                        sx={{
                          margin: 'auto',
                        }}
                      >
                        <Translate id={'chargeboxes.days.finishHour'} />
                      </TableCell>
                      {Days.map((e) => (
                        <TableCell
                          align='center'
                          sx={{
                            margin: 'auto',
                          }}
                        >
                          <Select
                            labelId='chargebox-custom-payment-consume-unit'
                            name={`${Days.indexOf(e)}.end`}
                            value={this.state.days[Days.indexOf(e)].end}
                            onChange={this.onChange}
                          >
                            {Hours.map((h) => (
                              <MenuItem value={h}>{h}</MenuItem>
                            ))}
                          </Select>
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableBody>
                </Table>
              </>
            )}
          </Grid>
        );
        break;
      case 'flat':
        fields = (
          <Grid container direction='column' alignItems='stretch' justifyContent='flex-start'>
            <Grid container direction='row' spacing={2}>
              <Grid item xs={12}>
                <TextField
                  label={this.props.translate('paymentTypes.amount')}
                  value={this.state.amount}
                  name='amount'
                  onChange={this.onChange}
                  fullWidth
                  InputProps={{
                    startAdornment: <InputAdornment position='start'>{currency}</InputAdornment>,
                  }}
                />
              </Grid>
            </Grid>
            <TextField
              label={this.props.translate('paymentTypes.minimumThreshold')}
              value={this.state.minimumThreshold === null ? '' : this.state.minimumThreshold.toString()}
              name='minimumThreshold'
              onChange={this.onChange}
              fullWidth
            />
          </Grid>
        );
        break;

      default:
        break;
    }
    return (
      <Dialog onClose={this.cancel} aria-labelledby='chargebox-dialog-custompayment-title' open={this.props.open} maxWidth='md'>
        <DialogTitle id='chargebox-dialog-custompayment-title'>
          <Translate id='chargeboxes.dialogs.customPayment.title' />
        </DialogTitle>
        <DialogContent>
          <Stepper activeStep={this.state.activeStep} style={{ marginBottom: 20 }}>
            <Step>
              <StepLabel>
                <Translate id='chargeboxes.dialogs.customPayment.page1' />
              </StepLabel>
            </Step>
            <Step>
              <StepLabel>
                <Translate id='chargeboxes.dialogs.customPayment.page2' />
              </StepLabel>
            </Step>
          </Stepper>

          {this.state.activeStep === 0 && (
            <>
              <Grid container direction='row' alignItems='center' justifyContent='center' spacing={2} className={this.props.classes.buttonsContainer}>
                <Grid item>
                  <Button
                    onClick={() => this.onChange({ target: { name: 'type', value: 'free' } })}
                    variant='contained'
                    color={this.state.type === 'free' ? 'primary' : 'default'}
                  >
                    <Translate id='paymentTypes.free' />
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    onClick={() => this.onChange({ target: { name: 'type', value: 'time-based' } })}
                    variant='contained'
                    color={this.state.type === 'time-based' ? 'primary' : 'default'}
                  >
                    <Translate id='paymentTypes.time-based' />
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    onClick={() => this.onChange({ target: { name: 'type', value: 'consume-based' } })}
                    variant='contained'
                    color={this.state.type === 'consume-based' ? 'primary' : 'default'}
                  >
                    <Translate id='paymentTypes.consume-based' />
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    onClick={() => this.onChange({ target: { name: 'type', value: 'flat' } })}
                    variant='contained'
                    color={this.state.type === 'flat' ? 'primary' : 'default'}
                  >
                    <Translate id='paymentTypes.flat' />
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    onClick={() => this.onChange({ target: { name: 'type', value: 'api' } })}
                    variant='contained'
                    color={this.state.type === 'api' ? 'primary' : 'default'}
                  >
                    <Translate id='paymentTypes.api' />
                  </Button>
                </Grid>
              </Grid>
              {fields}
            </>
          )}

          {this.state.activeStep === 1 && (
            <>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', position: 'sticky', left: 0 }}>
                <div>
                  <DialogContentText component='div'>{rfidDescription}</DialogContentText>
                  <RadioGroup name='chargeboxMode' value={this.state.chargeboxMode} onChange={this.onChange}>
                    <FormControlLabel
                      value='all'
                      control={<Radio color='primary' />}
                      label={this.props.translate('chargeboxes.dialogs.customPayment.enabledAll')}
                    />

                    <FormControlLabel
                      value='list'
                      control={<Radio color='primary' />}
                      label={this.props.translate('chargeboxes.dialogs.customPayment.enabledSel')}
                    />
                  </RadioGroup>

                  {/*<FormControlLabel
                    value='end'
                    control={
                      <Checkbox
                        checked={this.props.chargebox.custom_payment.chargeboxes === 'all' || !this.props.chargebox.custom_payment.chargeboxes}
                        name='enabledAll'
                        onClick={this.onChange}
                        color='primary'
                      />
                    }
                    label={this.props.translate('rfids.dialogs.infiniteOn.enabled')}
                    labelPlacement='end'
                  />
                  <FormControlLabel
                    value='end'
                    control={
                      <Checkbox
                        checked={this.props.chargebox.custom_payment.chargeboxes && this.props.chargebox.custom_payment.chargeboxes !== 'all'}
                        name='enabled'
                        onClick={this.onChange}
                        color='primary'
                      />
                    }
                    label={this.props.translate('rfids.dialogs.infiniteOn.enabled')}
                    labelPlacement='end'
                  />*/}
                </div>
                {this.state.chargeboxMode === 'list' && (
                  <div>
                    <IconButton onClick={this.openCloseFilters} style={{ width: '40px', height: '40px', position: 'absolute', bottom: 0, right: 0 }}>
                      <FilterListIcon />
                    </IconButton>
                  </div>
                )}
              </div>
              <br></br>
              <div>
                {this.state.chargeboxMode === 'list' && (
                  <Table
                    aria-label='table'
                    size='small'
                    style={
                      {
                        /*overflow: 'hidden'*/
                        /*backgroundColor: this.span && this.span.offsetWidth < this.span.scrollWidth ? 'green' : 'yellow',*/
                      }
                    }
                  >
                    <TableBody>
                      {this.state.ClientChargeboxes.map(
                        (row, index) =>
                          index % 3 === 0 && (
                            <TableRow key={index}>
                              <TableCell>
                                <Grid container direction='column' justifyContent='center'>
                                  <Checkbox
                                    checked={this.state.chargeboxMode === 'list' && this.state.chargeboxes && this.state.chargeboxes.includes(row.id)}
                                    name={row.id}
                                    onClick={(event) => {
                                      this.onChange({ target: { name: 'chargebox', value: event.target.name } });
                                    }}
                                    color='primary'
                                    style={{ alignSelf: 'center' }}
                                  />
                                  <label style={{ textAlign: 'center' }}>{row.alias}</label>
                                  <Typography variant='caption' style={{ textAlign: 'center', fontSize: '12px' }}>
                                    {row.id}
                                  </Typography>
                                </Grid>
                              </TableCell>
                              {index + 1 < this.state.ClientChargeboxes.length && (
                                <TableCell>
                                  <Grid container direction='column' justifyContent='center'>
                                    <Checkbox
                                      checked={
                                        this.state.chargeboxMode === 'list' &&
                                        this.state.chargeboxes &&
                                        this.state.chargeboxes.includes(this.state.ClientChargeboxes[index + 1].id)
                                      }
                                      id={this.state.ClientChargeboxes[index + 1].id}
                                      name={this.state.ClientChargeboxes[index + 1].id}
                                      onClick={(event) => {
                                        this.onChange({ target: { name: 'chargebox', value: event.target.name } });
                                      }}
                                      color='primary'
                                      style={{ alignSelf: 'center' }}
                                    />
                                    <label style={{ textAlign: 'center' }}>{this.state.ClientChargeboxes[index + 1].alias}</label>
                                    <Typography variant='caption' style={{ textAlign: 'center', fontSize: '12px' }}>
                                      {this.state.ClientChargeboxes[index + 1].id}
                                    </Typography>
                                  </Grid>
                                </TableCell>
                              )}
                              {index + 2 < this.state.ClientChargeboxes.length && (
                                <TableCell>
                                  <Grid container direction='column' justifyContent='center'>
                                    <Checkbox
                                      checked={
                                        this.state.chargeboxMode === 'list' &&
                                        this.state.chargeboxes &&
                                        this.state.chargeboxes.includes(this.state.ClientChargeboxes[index + 2].id)
                                      }
                                      id={this.state.ClientChargeboxes[index + 2].id}
                                      name={this.state.ClientChargeboxes[index + 2].id}
                                      onClick={(event) => {
                                        this.onChange({ target: { name: 'chargebox', value: event.target.name } });
                                      }}
                                      color='primary'
                                      style={{ alignSelf: 'center' }}
                                    />
                                    <label style={{ textAlign: 'center' }}>{this.state.ClientChargeboxes[index + 2].alias}</label>
                                    <Typography variant='caption' style={{ textAlign: 'center', fontSize: '12px' }}>
                                      {this.state.ClientChargeboxes[index + 2].id}
                                    </Typography>
                                  </Grid>
                                </TableCell>
                              )}
                            </TableRow>
                          ),
                      )}
                    </TableBody>
                  </Table>
                )}
              </div>
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Grid container direction='row' alignItems='center' justifyContent='space-between'>
            <Grid item>
              {this.state.showRemove && (
                <Button onClick={this.removeCustomPayment} color='primary'>
                  <Translate id='chargeboxes.dialogs.customPayment.removeCustomPayment' />
                </Button>
              )}
            </Grid>
            <Grid item>
              {/*<Button onClick={this.cancel} color='default' autoFocus>
                <Translate id='chargeboxes.dialogs.close' />
              </Button>*/}
              {this.state.activeStep > 0 ? (
                <Button onClick={this.handleBack} color='default' autoFocus>
                  <Translate id='chargeboxes.dialogs.customPayment.back' />
                </Button>
              ) : (
                <Button onClick={this.cancel} color='default' autoFocus>
                  <Translate id='chargeboxes.dialogs.close' />
                </Button>
              )}
              {/*<Button onClick={this.submit} color='primary' disabled={!this.canSubmit()}>
                <Translate id='chargeboxes.dialogs.customPayment.submit' />
              </Button>*/}
              {this.state.activeStep < 1 ? (
                <Button onClick={this.handleNext} color='primary' disabled={!this.canSubmit()}>
                  <Translate id='chargeboxes.dialogs.customPayment.continue' />
                </Button>
              ) : (
                <Button onClick={this.submit} color='primary' disabled={!this.canSubmit()}>
                  <Translate id='chargeboxes.dialogs.customPayment.submit' />
                </Button>
              )}
            </Grid>
          </Grid>
        </DialogActions>
        <FiltersMenu
          anchorEl={this.state.filtersMenuAnchorEl}
          onClose={this.openCloseFilters}
          filters={this.state.filters}
          submit={this.getFilteredChargeboxes}
          classes={this.props.classes}
        />
      </Dialog>
    );
  }
}

export default withStyles(styles)(withLocalize(RfidsDialogCustomPayment));
